import { BaseballDiamond } from "src/components/atoms/BaseballDiamond/BaseballDiamond";
import { processSprayChartData, SprayChartHitObject } from "src/components/util/spray-chart-helpers";
import * as Eden from "src/eden/content";

const Hit = ({ x, y, type }: { x: number; y: number; key: string; type: string }) => (
  <circle
    cx={x}
    cy={y}
    r="4"
    fill={["single", "double", "triple", "home_run"].indexOf(type) > -1 ? "#00D682" : "#B90018"}
    stroke={["single", "double", "triple", "home_run"].indexOf(type) > -1 ? "#009B4D" : "#61000D"}
    strokeWidth="1.143"
  />
);
type ParkSide = "left" | "right" | "center";
interface HomeRunProps {
  parkSide: ParkSide;
  count: number;
}
const HomeRun = ({ parkSide, count }: HomeRunProps) => {
  const { x, y } = getHomeRunLocation(parkSide);
  return (
    <g>
      <circle cx={x} cy={y} r="12" fill="#00D682" stroke="#009B4D" strokeWidth="1.143" />

      <text textAnchor="middle" x={x} y={y + 5}>
        {count}
      </text>
    </g>
  );
};
const getHomeRunLocation = (parkSide: ParkSide) => {
  switch (parkSide) {
    case "left":
      return { x: 30, y: 70 };
    case "center":
      return { x: 160, y: 25 };
    case "right":
      return { x: 290, y: 70 };
    default:
      return { x: 0, y: 0 };
  }
};

export const SprayChartGenerator = ({ sprayChartData }: { sprayChartData: Eden.SprayChartData[] }) => {
  const {
    hits,
    homeRuns: { left, right, center },
  }: SprayChartHitObject = processSprayChartData(sprayChartData);
  const hitElements = hits.map(({ x, y, key, type }) => <Hit x={x} y={y} key={key} type={type} />);
  const leftFieldHR = <HomeRun parkSide="left" count={left} />;
  const centerFieldHR = <HomeRun parkSide="center" count={center} />;
  const rightFieldHR = <HomeRun parkSide="right" count={right} />;

  return (
    <BaseballDiamond
      hitElements={hitElements}
      leftFieldHR={leftFieldHR}
      centerFieldHR={centerFieldHR}
      rightFieldHR={rightFieldHR}
      left={left}
      right={right}
      center={center}
    />
  );
};
